// extracted by mini-css-extract-plugin
module.exports = {"poweredBy":"ChangeSource_poweredBy__38SwW","section":"ChangeSource_section__SiQCN"};